export default "__VITE_ASSET__383ac5c9__"